import { EvaluationFormResult } from "interface/evaluationForm"
import { EvaluationResult, EvaluationSummary } from "./types"
import { LinearProgressProps } from "@mui/material"

const colors: LinearProgressProps["color"][] = [
  'primary',
  'secondary',
  'success',
  'warning'
]

export const evaluationSummary = (
  form: EvaluationFormResult | null,
  values: EvaluationResult[]
): EvaluationSummary => {
  const scoreValues = form?.scores || []
  const sections = form?.sections.map(({ sectionName, fields }, i) => {
    const maxScore = fields.reduce((sum, _) => scoreValues.reduce((max, sv) => Math.max(max, sv.score), 0) + sum, 0)
    const records = fields.map(({ contentFieldId, scoreFieldId }) => {
      const contentRecord = values.find(record => record.fieldId === contentFieldId)
      const scoreRecord = values.find(record => record.fieldId === scoreFieldId)
      const value = scoreRecord ? scoreValues.find(scoreValue => scoreValue.value === scoreRecord.value)?.score ?? 0 : 0
      return {
        contentFieldId,
        scoreFieldId,
        content: contentRecord?.value,
        score: scoreRecord?.value,
        value
      }
    })
    const color = colors[i % 4]
    return {
      sectionName,
      records,
      sectionTotal: records.reduce((sum, record) => sum + record.value, 0),
      maxScore,
      color
    }
  })
  const considerations = form?.considerations.map(consideration => {
    const content = values.find(record => record.fieldId === consideration)?.value
    return {
      fieldId: consideration,
      content
    }
  })
  const totalScore = sections?.reduce((sum, section) => sum + section.sectionTotal, 0)
  const judgement = form?.judgements.find(({ minScore, maxScore }) => {
    const total = sections?.reduce((sum, section) => sum + section.sectionTotal, 0) ?? 0
    return total >= minScore && total <= maxScore
  })?.label
  return {
    sections,
    totalScore,
    judgement,
    maxScore: sections?.reduce((sum, section) => sum + section.maxScore, 0),
    considerations
  }
}